/** @flow */
import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
} from "@modules/reporting/reducer/reports/referral-details/types";

export const defaultReports = (state: State): Array<DefaultReports> =>
  state.reporting.reports.referralDetails.defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> =>
  state.reporting.reports.referralDetails.mySavedReports;

export const getReportData = (state: State): Array<Object> =>
  state.reporting.reports.referralDetails.reportData.content;

export const getCurrentReport = (state: State): ?Object =>
  (state.reporting.reports.referralDetails.currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object =>
  state.reporting.reports.referralDetails.currentCharts;

export const getReferralDetailsFiltersSchema = (state: State): ?Object =>
  state.reporting.reports.referralDetails.referralDetailsFiltersSchema;

export const getReportToSave = (state: State): ?Object =>
  state.reporting.reports.referralDetails.reportToSave;

export const isLoading = (state: State): boolean =>
  state.reporting.reports.referralDetails.requestsInProgress > 0;
